import { BranchDetailsAlertOutput } from './branch-details-alert-output.model';
import { VehicleTypeAlertOutput } from './vehicle-type-alert-output.model';
import { VehicleDetailsAlertOutput } from './vehicle-details-alert-output.model';


export class AlertGroupSelectByIdOutputData implements IAlertGroupSelectByIdOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The branch details type must be one of "All" or "Select" */
    branch_detail_type!: string;
    /** The vehicle type must be one of "All" or "Select" */
    vehicle_type!: string;
    /** The vehicle details type must be one of "All" or "Select" */
    vehicle_details_type!: string;
    /** The alert group name with 255 character limit */
    alert_group_name!: string;
    /** The valid days must be one of "Everyday" or "Custom" */
    valid_days!: string;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    sunday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    monday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    tuesday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    wednesday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    thursday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    friday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    saturday!: number;
    /** The alert from time with 10 character limit */
    from_time!: string;
    /** The alert to time with 10 character limit */
    to_time!: string;
    /** The auto-generated id of the time zone master */
    time_zone_id!: number;
    alert_group_branch_details!: BranchDetailsAlertOutput[];
    vehicle_type_alert_group!: VehicleTypeAlertOutput[];
    vehicle_details_alert_group!: VehicleDetailsAlertOutput[];
    status!: number;

    constructor(data?: IAlertGroupSelectByIdOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alert_group_id = _data["alert_group_id"];
            this.company_details_id = _data["company_details_id"];
            this.branch_detail_type = _data["branch_detail_type"];
            this.vehicle_type = _data["vehicle_type"];
            this.vehicle_details_type = _data["vehicle_details_type"];
            this.alert_group_name = _data["alert_group_name"];
            this.valid_days = _data["valid_days"];
            this.sunday = _data["sunday"];
            this.monday = _data["monday"];
            this.tuesday = _data["tuesday"];
            this.wednesday = _data["wednesday"];
            this.thursday = _data["thursday"];
            this.friday = _data["friday"];
            this.saturday = _data["saturday"];
            this.from_time = _data["from_time"];
            this.to_time = _data["to_time"];
            this.time_zone_id = _data["time_zone_id"];
            if (Array.isArray(_data["alert_group_branch_details"])) {
                this.alert_group_branch_details = [] as any;
                for (let item of _data["alert_group_branch_details"])
                    this.alert_group_branch_details!.push(BranchDetailsAlertOutput.fromJS(item));
            }
            if (Array.isArray(_data["vehicle_type_alert_group"])) {
                this.vehicle_type_alert_group = [] as any;
                for (let item of _data["vehicle_type_alert_group"])
                    this.vehicle_type_alert_group!.push(VehicleTypeAlertOutput.fromJS(item));
            }
            if (Array.isArray(_data["vehicle_details_alert_group"])) {
                this.vehicle_details_alert_group = [] as any;
                for (let item of _data["vehicle_details_alert_group"])
                    this.vehicle_details_alert_group!.push(VehicleDetailsAlertOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AlertGroupSelectByIdOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new AlertGroupSelectByIdOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert_group_id"] = this.alert_group_id;
        data["company_details_id"] = this.company_details_id;
        data["branch_detail_type"] = this.branch_detail_type;
        data["vehicle_type"] = this.vehicle_type;
        data["vehicle_details_type"] = this.vehicle_details_type;
        data["alert_group_name"] = this.alert_group_name;
        data["valid_days"] = this.valid_days;
        data["sunday"] = this.sunday;
        data["monday"] = this.monday;
        data["tuesday"] = this.tuesday;
        data["wednesday"] = this.wednesday;
        data["thursday"] = this.thursday;
        data["friday"] = this.friday;
        data["saturday"] = this.saturday;
        data["from_time"] = this.from_time;
        data["to_time"] = this.to_time;
        data["time_zone_id"] = this.time_zone_id;
        if (Array.isArray(this.alert_group_branch_details)) {
            data["alert_group_branch_details"] = [];
            for (let item of this.alert_group_branch_details)
                data["alert_group_branch_details"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicle_type_alert_group)) {
            data["vehicle_type_alert_group"] = [];
            for (let item of this.vehicle_type_alert_group)
                data["vehicle_type_alert_group"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicle_details_alert_group)) {
            data["vehicle_details_alert_group"] = [];
            for (let item of this.vehicle_details_alert_group)
                data["vehicle_details_alert_group"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IAlertGroupSelectByIdOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The branch details type must be one of "All" or "Select" */
    branch_detail_type: string;
    /** The vehicle type must be one of "All" or "Select" */
    vehicle_type: string;
    /** The vehicle details type must be one of "All" or "Select" */
    vehicle_details_type: string;
    /** The alert group name with 255 character limit */
    alert_group_name: string;
    /** The valid days must be one of "Everyday" or "Custom" */
    valid_days: string;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    sunday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    monday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    tuesday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    wednesday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    thursday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    friday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    saturday: number;
    /** The alert from time with 10 character limit */
    from_time: string;
    /** The alert to time with 10 character limit */
    to_time: string;
    /** The auto-generated id of the time zone master */
    time_zone_id: number;
    alert_group_branch_details: BranchDetailsAlertOutput[];
    vehicle_type_alert_group: VehicleTypeAlertOutput[];
    vehicle_details_alert_group: VehicleDetailsAlertOutput[];
    status: number;
}

